export default "__VITE_ASSET__DpOm1S2B__"